import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Phone, Menu, X, MessageSquareText, Wrench } from "lucide-react";
import { SITE } from "../config/site";
import { QuoteButton } from "./CTAButtons";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/brake-replacement", label: "Brake Replacement" },
  { to: "/services", label: "Services" },
  { to: "/service-areas", label: "Service Areas" },
  { to: "/reviews", label: "Reviews" },
];

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-edge bg-obsidian/85 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <Link to="/" data-testid="header-logo-link" className="group flex items-center gap-2.5" onClick={() => setOpen(false)}>
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-crimson shadow-md shadow-crimson/30 transition-transform duration-300 group-hover:-rotate-12">
            <Wrench className="h-5 w-5 text-white" />
          </span>
          <span className="flex items-baseline gap-1.5">
            <span className="font-display text-xl font-extrabold uppercase tracking-tight text-slate-50 sm:text-2xl">
              My Mobile <span className="text-crimson">Mechanic</span>
            </span>
            <span className="rounded-md bg-crimson/10 px-1.5 py-0.5 font-mono text-[11px] font-bold tracking-wider text-crimson">
              978
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-6 lg:flex" aria-label="Primary">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}-link`}
              className={({ isActive }) =>
                `text-sm font-semibold uppercase tracking-wide transition-colors ${
                  isActive ? "text-amber2" : "text-slate-300 hover:text-white"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-4 lg:flex">
          <a
            href={SITE.phoneHref}
            data-testid="header-phone-link"
            className="flex items-center gap-2 text-sm font-bold text-slate-200 transition-colors hover:text-amber2"
          >
            <Phone className="h-4 w-4 text-crimson" />
            {SITE.phone}
          </a>
          <QuoteButton className="!min-h-[44px] !px-5 !text-base" testid="header-get-quote-button" />
        </div>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen(!open)}
          className="flex h-11 w-11 items-center justify-center border border-edge text-slate-200 lg:hidden"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <nav className="border-t border-edge bg-obsidian px-4 pb-6 pt-2 lg:hidden" aria-label="Mobile">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}-link`}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block border-b border-edge/60 py-3.5 font-display text-2xl font-bold uppercase tracking-tight ${
                  isActive ? "text-amber2" : "text-slate-200"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
          <div className="mt-4">
            <QuoteButton className="w-full" testid="mobile-menu-quote-button" />
          </div>
          <div className="mt-3 grid grid-cols-2 gap-3">
            <a
              href={SITE.phoneHref}
              data-testid="mobile-menu-call-button"
              className="flex min-h-[52px] items-center justify-center gap-2 border-2 border-crimson font-display text-lg font-bold uppercase text-crimson transition-colors hover:bg-crimson hover:text-white"
            >
              <Phone className="h-5 w-5" /> Call
            </a>
            <a
              href={SITE.smsHref}
              data-testid="mobile-menu-text-button"
              className="flex min-h-[52px] items-center justify-center gap-2 border-2 border-edgehi font-display text-lg font-bold uppercase text-slate-100 transition-colors hover:border-amber2 hover:text-amber2"
            >
              <MessageSquareText className="h-5 w-5" /> Text
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}
